import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import { useAtomValue } from 'jotai';
import { currentContextAtom } from '../../state';
import useNormalizedCurrentRefinements from '../../hooks/useNormalizedCurrentRefinements';

export default function MyDeliveryZonesFilter(): React.JSX.Element {
  const { t } = useTranslation(['discovery']);
  const [isActivated, setIsActivated] = useState(true);

  const { deliveryZones } = useAtomValue(currentContextAtom);
  const { refine: refineAdministrativeArea } = useRefinementList({ attribute: 'administrative_areas', limit: 1000 });
  const currentAreaFilters = useNormalizedCurrentRefinements('administrative_areas') as string[];

  const areaFilterValue = (area: string): string => {
    return `administrative_area_level_2|${area!}`;
  };

  const addDeliveryZonesInFilters = (): void => {
    deliveryZones?.forEach(({ administrative_areas }) => {
      administrative_areas?.forEach(({ area }) => {
        if (area !== 'ALL_AREAS' && !currentAreaFilters.includes(areaFilterValue(area!))) {
          refineAdministrativeArea(areaFilterValue(area!));
        }
      });
    });
  };

  const removeDeliveryZonesInFilters = (): void => {
    deliveryZones?.forEach(({ administrative_areas }) => {
      administrative_areas?.forEach(({ area }) => {
        if (currentAreaFilters.includes(areaFilterValue(area!))) {
          refineAdministrativeArea(areaFilterValue(area!));
        }
      });
    });
  };

  // If areas from the user delivery zones are changed in the filters list we should update the filter activated mark
  useEffect(() => {
    const filteredZones = deliveryZones?.filter(
      (zone) => zone.administrative_areas[0].area !== 'ALL_AREAS',
    );

    const allDeliveryZonesAreInFilters = filteredZones?.every((zone) => {
      return zone.administrative_areas.every(({ area }) => currentAreaFilters.includes(areaFilterValue(area)));
    });

    if (isActivated && !allDeliveryZonesAreInFilters) {
      setIsActivated(false);
    }

    if (!isActivated && allDeliveryZonesAreInFilters) {
      setIsActivated(true);
    }
  }, [currentAreaFilters]);

  const toggleFilter = (): void => {
    const isNowActivated = !isActivated;
    setIsActivated(isNowActivated);

    if (isNowActivated) {
      addDeliveryZonesInFilters();
    } else {
      removeDeliveryZonesInFilters();
    }
  };

  return (
    <Chip
      variant="filter"
      className={isActivated ? 'Kheops-selected' : ''}
      label={t('discovery:my_delivery_zones')}
      onClick={toggleFilter}
    />
  );
}
